export default __webpack_public_path__ + "static/congrats-tab-510399c70296e9cc07afa258fb8fdd33.png";